"use strict";

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UrlUtils = /*#__PURE__*/function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }

  _createClass(UrlUtils, null, [{
    key: "getParam",

    /**
     * Retrieve requested paramater value from URL
     * Reference: https://stackoverflow.com/a/979997
     *
     * @param {String} url
     * @param {String} param
     * @returns {String} (value)
     */
    value: function getParam(url, param) {
      if (!url) {
        url = location.href;
      }

      param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regexS = "[\\?&]".concat(param, "=([^&#]*)"),
          regex = new RegExp(regexS),
          results = regex.exec(url);
      return results == null ? null : decodeURI(results[1]);
    }
  }, {
    key: "getParamsFromQueryString",
    value: function getParamsFromQueryString(query) {
      // Remove the leading '?' if it's there.
      var trimmedQuery = query.replace(/^\?/, ''); // Retain only query params

      if (trimmedQuery.indexOf('?') !== -1) {
        trimmedQuery = trimmedQuery.substring(trimmedQuery.indexOf('?') + 1, trimmedQuery.length);
      }

      var pairStrings = trimmedQuery.split('&');
      var pairs = pairStrings.map(function (str) {
        return str.split('=').map(function (val) {
          return decodeURIComponent(val);
        });
      });
      return pairs.reduce(function (params, currentPair) {
        var key = currentPair[0];
        var value = currentPair[1];

        if (!params.hasOwnProperty(key)) {
          params[key] = value;
        } else {
          if (typeof params[key] === 'string') {
            params[key] = [params[key], value];
          } else {
            params[key].push(value);
          }
        }

        return params;
      }, {});
    }
    /**
     * Replaces placeholders in a URL
     *
     * E.g.
     * insertUrlParams('/claims/:claimNo/details', { claimNo: '1234' }) => '/claims/123/details'
     *
     * @param {String} url
     * @param {Object} params
     * @returns {String} (value)
     */

  }, {
    key: "insertUrlParams",
    value: function insertUrlParams(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return url.replace(/:(\w+)(?:\/|$)/g, function (match, paramkey) {
        return "".concat(params[paramkey], "/");
      });
    }
    /**
     * Tests is a url is absolute or relative
     * Reference: https://stackoverflow.com/a/19709846/5059401
     *
     * @param {String} url
     * @returns {Boolean} (value)
     */

  }, {
    key: "isAbsoluteUrl",
    value: function isAbsoluteUrl(url) {
      var r = new RegExp('^(?:[a-z]+:)?//', 'i');
      return r.test(url);
    }
    /**
     * Retrieve requested paramater value from URL
     * Reference: https://stackoverflow.com/a/979997
     * Duplicate of getParam
     * @param {String} url
     * @param {String} param
     * @returns {String} (value)
     */

  }, {
    key: "urlParam",
    value: function urlParam(url, param) {
      if (!url) {
        url = location.href;
      }

      param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regexS = "[\\?&]".concat(param, "=([^&#]*)"),
          regex = new RegExp(regexS),
          results = regex.exec(url);
      return results === null ? null : decodeURI(results[1]);
    }
  }]);

  return UrlUtils;
}();

exports.default = UrlUtils;
//# sourceMappingURL=UrlUtils.js.map